export enum CommonButtons {
  // Primary Actions
  Ok = 'hDrA',
  Continue = 'Mfvv',
  Enter = '7Ut+',
  Next = 'E2HV',

  // Confirmation
  Yes = 'haOa',
  No = 'HqRC',
  Confirm = '7r3S',

  // Secondary Actions
  Close = 'fZ63',
  Retry = 'lCCH',
  Clear = 'g7Es',
  Add = 'n9co',

  // Special Actions
  ResetTerminal = 'zERx',
  ForceReset = 'Id9k',
  BackToList = 'KWyV',
  SaveAndContinue = 'aEtF',
}
